<template>
	<div class="modal fade modal-shipping" id="modal-shipping" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
	  <div class="modal-dialog" role="document">
	    <div class="modal-content">
	      <div class="modal-header">
	        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span class="close" aria-hidden="true">&times;</span></button>
	        <h2 class="text-uppercase no-margin">Envíos</h2>
	      </div>
	      <div class="modal-body">
	      	<h2 class="text-uppercase title">¿A qué lugares envían?</h2>
	      	<p>Hacemos envíos a todo México. Si quieres consultar cobertura en alguna ciudad en específico comunícate con nosotros al (33) 2748 2493.</p>
	      	<h2 class="text-uppercase title">¿En cuánto tiempo recibiré mi pedido?</h2>
	      	<p>
	      		Para el envío tomamos en cuenta el producto con mayor tiempo de entrega de los que elegiste en tu pedido. El tiempo máximo de entrega lo puedes ver dentro de la ficha de cada modelo. Una vez que documentamos tu pedido con el transportista, la entrega en domicilio se realiza de 2 a 5 días hábiles, dependiendo de la ciudad de entrega.
	      	</p>
	      	<h2 class="text-uppercase title">¿cómo entregan mi pedido?</h2>
	      	<p>Los pedidos se entregan a pie de banqueta. La programación de horario y día de entrega la hace directamente el transportista. Algunos modelos pueden llegar desarmados. Los envíos se hacen por cobrar y el costo de envío se paga directamente al recibir. </p>
			<h2 class="text-uppercase title">¿Cuál es el costo de las entregas?</h2>
			<p>
				Esto depende de la totalidad de tu pedido. El costo de envío se calcula en base al volumen de todas las piezas que integran tu pedido y al domicilio de entrega. Antes de finalizar tu proceso de compra podrás ver el costo estimado del envío. El monto exacto te lo hacemos llegar a tu correo junto con tu número de rastreo una vez que se documente tu pedido con el transportista. En el caso de FEDEX el costo del envío se adiciona a tu pedido, en el caso de Paquetería el pago es en efectivo al momento de recibir su mercancía. Dentro de la zona metropolitana de Guadalajara la entrega es gratuita.
			</p>
			<h2 class="text-uppercase title">¿Qué hago si recibo un producto dañado?</h2>
			<p>
				Te pedimos tomar fotos de los daños para comprobar si es problema de fábrica o daño durante el envío. Dependiendo de cuál es el caso la serie de pasos a seguir es distinta. Te lo explicamos detallado dentro de nuestras políticas de envío dando <a href="/terminos-y-condiciones#politica-de-devoluciones" @click="goFaqCloseModal">CLICK AQUÍ</a>.
			</p>
			<h2 class="text-uppercase title">¿Más dudas?</h2>
			<p>
				Para más información da <a v-link="{ path: '/preguntas-frecuentes' }" @click="goFaqCloseModal">CLICK AQUÍ</a> o llámanos al (33) 2748 2493.
			</p>
	      </div>
	    </div>
	  </div>
	</div>
</template>

<script>
export default {
	methods: {
		goFaqCloseModal () {
			$('.close').trigger('click');
		}
	}
}
</script>



// WEBPACK FOOTER //
// Modal-shipping.vue?17b97f8a